import { createContext } from 'react';

const ChallengeSearchQueryContext = createContext<string>('');

export default ChallengeSearchQueryContext;
